<!--
@Time : 2020/11/29 7:22 下午
@Author : yekong
@File : top.vue
@Software : PhpStorm
-->
<template>
  <div class="top">
    <div class="item">
      <div class="top1">
        TOP1
      </div>
      <div class="title2">北京</div>
      <div class="hs">
        <p class="p1">45</p>
        <p class="p2">耗时</p>
        <p class="p3">90</p>
        <p class="p4">得分</p>
      </div>
    </div>
    <div class="item">
      <div class="top1 top2">
        TOP2
      </div>
      <div class="title2">上海</div>
      <div class="hs">
        <p class="p1">45</p>
        <p class="p2">耗时</p>
        <p class="p3">90</p>
        <p class="p4">得分</p>
      </div>
    </div>
    <div class="item">
      <div class="top1 top3">
        TOP3
      </div>
      <div class="title2">深圳</div>
      <div class="hs">
        <p class="p1">45</p>
        <p class="p2">耗时</p>
        <p class="p3">90</p>
        <p class="p4">得分</p>
      </div>
    </div>
    <div class="item">
      <div class="top1 top4">
        TOP4
      </div>
      <div class="title2">大连</div>
      <div class="hs">
        <p class="p1">45</p>
        <p class="p2">耗时</p>
        <p class="p3">90</p>
        <p class="p4">得分</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.item {
  width: 201px;
  height: 222px;
  border: 1px solid #FFFFFF;
  position: relative;

  .top1 {
    width: 86px;
    height: 29px;
    background: #B85C3E;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 18px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    position: absolute;
    left: -10px;
    top: -10px;
  }

  .title2 {
    width: 201px;
    height: 72px;
    background: #B7C1D4;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0C1638;
  }
}

.hs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 145px;

  .p1 {
    font-size: 36px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: #FEFEFF;
    height: 30px;
  }

  .p2 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FEFEFF;
    margin-bottom: 15px;
  }

  .p3 {
    font-size: 36px;
    height: 30px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: #FEFEFF;
  }

  .p4 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FEFEFF;
  }

}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-top: 40px;
  padding-left: 10px;

}

.top4 {
  background: rgba(77, 93, 142, 1) !important;
}

.top3 {
  background: rgba(60, 175, 133, 1) !important;
}

.top2 {
  background: rgba(53, 121, 246, 1) !important;
}
</style>
